import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-md-550px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5 row" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder col-3" }
const _hoisted_4 = { class: "d-flex justify-content-end col-9" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_8 = { class: "px-7 py-5 row" }
const _hoisted_9 = { class: "mb-5 col-5" }
const _hoisted_10 = { class: "fs-7 mb-5 form-label fw-bold" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-check-label user-select-none" }
const _hoisted_13 = { class: "mb-10 col-6" }
const _hoisted_14 = { class: "form-label fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("filters")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
          type: "reset",
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true",
          disabled: 
            _ctx.filterDate.length == 0 &&
            _ctx.haveFilter == false &&
            _ctx.filtersChanged == false
          
        }, _toDisplayString(_ctx.$t("deleteFilters")), 9, _hoisted_5),
        _createElementVNode("button", {
          type: "submit",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFilters && _ctx.setFilters(...args))),
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true",
          disabled: 
            _ctx.filterDate.length == 0 ||
            (_ctx.actualDate == _ctx.filterDate &&
              !Array.isArray(_ctx.filterDate) &&
              _ctx.filtersChanged == false)
          
        }, _toDisplayString(_ctx.$t("ok")), 9, _hoisted_6)
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("typeIncident")), 1),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeIncidents, (typeIncident) => {
            return (_openBlock(), _createElementBlock("label", {
              class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5",
              key: typeIncident.Name
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: typeIncident.Id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.LandIncidentTypeID) = $event))
              }, null, 8, _hoisted_11), [
                [_vModelCheckbox, _ctx.filters.LandIncidentTypeID]
              ]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`typelandIncident.${typeIncident.Name}`)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("dates")), 1),
        _createVNode(_component_Datepicker, {
          modelValue: _ctx.filterDate,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterDate) = $event)),
          minDate: _ctx.minDate,
          maxDate: 
            _ctx.maxDate == null
              ? new Date()
              : _ctx.maxDate < new Date()
              ? _ctx.maxDate
              : new Date()
          ,
          autoRange: 6,
          enableTimePicker: false,
          startTime: [
            { hours: 0, minutes: 0, seconds: 0 },
            { hours: 23, minutes: 59, seconds: 59 },
          ],
          range: "",
          inline: "",
          autoApply: ""
        }, null, 8, ["modelValue", "minDate", "maxDate"])
      ])
    ])
  ]))
}